<template>
  <div class="selectpricewrap">
    <div v-if="disable_select">
      <!-- 禁止货币选择时候，如果传入国家还是会根据传入的国家显示货币符号和汇率，可满足showtime主题在开启货币选择时仅在头部显示货币列表，商品列表处价格样式任然显示被禁用的样式，
      此时只需要在外部传入$store里国家，并且disable_select为真即可满足需求，若仅disable_select为真，不传入国家则会使用结账国家符号，汇率 -->
      <span class="product_price_price">
        <span
          class="money"
          :class="saletag?'saveprice':'price_text'"
          :style="{fontSize:fontSize+'px'}"
        >{{country?getSymbolFromCurrency(country):getSymbolFromCurrency(this.$store.state.checkoutcurrency)}} {{computePrice(price,disable_select,country)}} {{country}}</span>
      </span>
      <span v-if="regular_price_num" class="product_price_cross">
        <span
          class="money regular_price_text"
          :style="{fontSize:regularFontSize+'px'}"
        >{{country?getSymbolFromCurrency(country):getSymbolFromCurrency(this.$store.state.checkoutcurrency)}}{{computePrice(regular_price_num,disable_select,country)}}</span>
      </span>
    </div>
    <div v-else-if="noprice">
        <div ref="selectpricewrap" :style="noprice_style"  @click.stop.prevent="showpricelist($event)">   {{$store.state.pricetype}} <span class="iconfont">&#xe63c; </span>
          <v-pricelist :appendToBody="appendToBody" :type="type"></v-pricelist>
        </div>
    </div>
    <div v-else>
      <i
        class="price regular_price_text"
        :style="{fontSize:regularFontSize+'px'}"
        v-if="regular_price_num"
      >
        <span v-if="this.$store.state.pricetype=='CNY'">CN</span>
        {{`${getSymbolFromCurrency(this.$store.state.pricetype)} ${computePrice(regular_price_num)} ${$store.state.pricetype}`}}
      </i>
      <div
        class="selectpricewrap"
        @click.stop.prevent="showpricelist($event)"
        ref="selectpricewrap"
      >
        <div class="selectprice">
          <i
            class="price"
            :class="regular_price?'regular_price_text':'price_text'"
            :style="{fontSize:fontSize+'px'}"
          >
            <span v-if="this.$store.state.pricetype=='CNY'">CN</span>
            {{`${getSymbolFromCurrency(this.$store.state.pricetype)} ${computePrice(price)} ${$store.state.pricetype}`}}
          </i>
          <b class="iconfont" :style="{fontSize:fontSize-2+'px'}">&#xe60b;</b>
        </div>
        <v-pricelist :appendToBody="appendToBody" :type="type"></v-pricelist>
        <!-- <div class="pricelistbox" :class="type==='quickPurchased'?'quick_pricelistbox':''">
          <ul class="pricelist" ref="pricelist" @click.prevent.stop="clickpricelist">
            <li
              v-if="this.$store.state.rates[this.$store.state.currentcountry]"
              style="text-transform:capitalize;"
            >
              <div></div>
              <span>Auto</span>
            </li>
            <li v-if="this.$store.state.rates.AUD">
              <div></div>
              <span :class="this.$store.state.pricetype=='AUD'?'bold':''">AUD</span>
            </li>
            <li v-if="this.$store.state.rates.CAD">
              <div></div>
              <span :class="this.$store.state.pricetype=='CAD'?'bold':''">CAD</span>
            </li>
            <li v-if="this.$store.state.rates.CNY">
              <div></div>
              <span :class="this.$store.state.pricetype=='CNY'?'bold':''">CNY</span>
            </li>
            <li v-if="this.$store.state.rates.EUR">
              <div></div>
              <span :class="this.$store.state.pricetype=='EUR'?'bold':''">EUR</span>
            </li>
            <li v-if="this.$store.state.rates.GBP">
              <div></div>
              <span :class="this.$store.state.pricetype=='GBP'?'bold':''">GBP</span>
            </li>
            <li v-if="this.$store.state.rates.JPY">
              <div></div>
              <span :class="this.$store.state.pricetype=='JPY'?'bold':''">JPY</span>
            </li>
            <li v-if="this.$store.state.rates.NZD">
              <div></div>
              <span :class="this.$store.state.pricetype=='NZD'?'bold':''">NZD</span>
            </li>
            <li v-if="this.$store.state.rates.USD">
              <div></div>
              <span :class="this.$store.state.pricetype=='USD'?'bold':''">USD</span>
            </li>
          </ul>
        </div>-->
      </div>
    </div>
  </div>
</template>
<script>
import API from "../../API.js";
import getSymbolFromCurrency from "currency-symbol-map";
import vPricelist from "./pricelist";
export default {
  props: [
    "price",
    "regular_price_num",
    "regular_price",
    "fontSize",
    "type",
    "regularFontSize",
    "disable_select",
    "country",
    "appendToBody",
    "noprice",
    "noprice_style",
    "saletag"
  ],
  data() {
    return {
      totalprice: "",
      symbol: {
        AUTO: "$",
        AUD: "$",
        CAD: "$",
        CNY: "CN ￥",
        EUR: "€",
        GBP: "£",
        JPY: "￥",
        NZD: "$",
        USD: "$"
      },
      show: true,
      getSymbolFromCurrency: ""
    };
  },
  methods: {
    showpricelist(e) {
      this.$(".pricelist").css("display", "none");
      if (this.show) {
        if (this.appendToBody !== false) {
          let el = this.$(this.$el.childNodes[0].lastChild);
          let offset = el.offset();
          let height = el.outerHeight();
          this.$("body>.pricelistbox").css({
            top: offset.top + height + "px",
            left: offset.left + "px"
          });
          this.$("body>.pricelistbox>.pricelist").animate(
            { height: "toggle", opacity: "toggle" },
            300
          );
        } else {
          this.$(this.$el.childNodes[0].lastChild.lastChild.lastChild).animate(
            { height: "toggle", opacity: "toggle" },
            300
          );
        }
      }
      this.show = !this.show;
      // this.$(this.$refs.pricelist).slideToggle(300);
      // this.$(this.$refs.pricelist).fadeToggle(300);
    }
    // clickpricelist(e) {
    //   this.show = true;
    //   if (e.target.parentNode.tagName == "LI") {
    //     // 判断如果是auto的话 存入自动获取的当前国家
    //     var pricetype =
    //       e.target.parentNode.lastChild.innerText == "Auto"
    //         ? this.$store.state.currentcountry
    //         : e.target.parentNode.lastChild.innerText;
    //     this.$(".pricelist").css("display", "none");
    //     localStorage.setItem("pricetype", pricetype);
    //     this.$store.dispatch("changepricetype", pricetype);
    //   } else if (e.target.tagName == "LI") {
    //     var pricetype =
    //       e.target.lastChild.innerText == "Auto"
    //         ? this.$store.state.currentcountry
    //         : e.target.lastChild.innerText;
    //     this.$(".pricelist").css("display", "none");
    //     localStorage.setItem("pricetype", pricetype);
    //     this.$store.dispatch("changepricetype", pricetype);
    //   }
    // },
  },
  beforeMount() {
    this.getSymbolFromCurrency = getSymbolFromCurrency;
  },
  mounted() {
    console.log('countrycountrycountry',this.country);
    this.$(".pricelist>li").click(() => {
      console.log("this.show=true");
      this.show = true;
    });
    document.body.addEventListener(
      "click",
      () => {
        this.$(".pricelist").css("display", "none");
        this.show = true;
      },
      false
    );
  },
  components: {
    vPricelist
  }
};
</script>
<style scoped lang='scss'>
.regular_price_text {
  text-decoration: line-through !important;
  margin-right: 10px;
  cursor: auto;
  font-style: normal;
}
.product_price_price {
  font-family: "oswald", sans-serif;
  line-height: 1;
  font-size: 20px;
  margin-top: 6px;
  cursor: auto;
}
.product_price_cross {
  font-family: "oswald", sans-serif;
  position: relative;
  margin-left: 6px;
  text-decoration: line-through;
  color: #b89797;
  font-size: 17px;
  cursor: auto;
}
.selectpricewrap {
  display: inline-block;
  line-height: 1.5;
  cursor: pointer;
  -webkit-tap-highlight-color: rgba(23, 178, 235, 0.3) !important;
  ul {
    padding: 0;
    li {
      list-style: none;
    }
  }
  .selectprice {
    display: inline-block;
    border: 1px solid rgb(240, 240, 240);
    padding: 2px;
    color: black;
    white-space: nowrap;
    font-size: 14px;
    .price {
      color: #b00404;
      font-weight: 400;
      font-style: normal;
    }

    & > b {
      vertical-align: baseline;
    }
    &:hover {
      opacity: 0.8;
    }
  }
}
</style>